<template>
  <div>
    <v-container fluid v-if="!EditdialogUser && !AddVector">
      <v-overlay
      v-model="showSuccess"
      :scrim="true"
      opacity="0.3"
      persistent
      :z-index="9900"
    >
    </v-overlay>
      <transition name="fade-slide">
        <div v-if="showSuccess" class="success-toast" role="status">
          <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
          <span style="font-size: 15px; font-weight: 600;">{{ successMessage }}</span>
        </div>
      </transition>
      <!-- <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("NegativeDataset_title")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader> -->
      <v-card class="card2">
        <v-card-text>
          <v-row style="display: flex; justify-content: space-between; padding: 0 2px;">
            <v-col cols="12" md="5" class="mt-1">
              <span style="font-weight: 700; font-size: 24px;">Negative Question Set</span>
            </v-col>
            <v-col cols="12" md="6" class="d-flex flex-wrap justify-end gap-2 mr-2">
              <v-row align="center" justify="end" style="gap: 20px;">
                <v-text-field
                  v-model="searchNegativeName"
                  placeholder="Negative Question Set Name"
                  hide-details
                  variant="plain"
                  class="search-input"
                  density="comfortable"
                  @update:modelValue="queueSearch"
                  @keydown.enter.prevent="triggerSearch"
                  @click:clear="clearSearch"
                >
                  <template #prepend-inner>
                    <img
                      class="search-icon"
                      src="@/assets/flowbite_search-outline.svg"
                      alt="Search"
                      width="20"
                      height="20"
                    />
                  </template>
                </v-text-field>
                <button
                  id="button-add-productgroup"
                  type="button"
                  class="products-header-button"
                  @click="Add()"
                >
                  <img src="@/assets/ic_round-plus.svg" alt="img" width="20" height="20" />
                  <span style="color: #ffffff; font-size: 14px;">{{ $t("add") }}</span>
                </button>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-data-table-server
          v-model:options="options"
          :items-per-page="itemsPerPage"
          :items-length="searchTotalTable"
          :items="dataTable"
          :headers="headers"
          :loading="loadingTable"
          class="pa-4"
        >
          <template #no-data>
            <div style="text-align: center;">
              <span style="color: #646464; font-weight: 400;">No Data Available</span>
            </div>
          </template>

          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: left">{{ item.number }}</td>
              <td>{{ item.name }}</td>
              <td style="text-align: left">{{ item.createBy }}</td>
              <td style="text-align: left">
                <div class="d-flex align-center justify-center gap-2">
                  <button type="button"
                    id="button-edit-validationnegative"
                    variant="text"
                    density="comfortable"
                    @click="Edit(item)"
                    class="action-btn edit-btn"
                    icon
                  >
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/Edit.svg"
                          alt="img"
                          width="22"
                          height="22"
                        />
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                  </button>
                  
                  <button type="button"
                    id="button-delete-validationnegative"
                    variant="text"
                    density="comfortable"
                    @click="openDeleteDialog(item.id)"
                  >
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/Group.svg"
                          alt="img"
                          width="22"
                          height="19"
                        />
                      </template>
                      <span>Delete</span>
                    </v-tooltip>
                  </button>
                </div>
              </td>
            </tr>
          </template>

          <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4 py-2"
              style="width: 100%"
            >
              <div>Total results {{ searchTotalTable }}</div>

              <v-data-table-footer
                :items="[
                  { text: '10', value: 10 },
                  { text: '25', value: 25 },
                  { text: '50', value: 50 },
                  { text: '100', value: 100 },
                  { text: 'All', value: -1 },
                ]"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>
        </v-data-table-server>

        <!-- Delete Dialog -->
        <v-dialog v-model="showDeleteDialog" max-width="570" class="delete-dialog-group">
          <v-card class="delete-dialog-card">
            <v-card-title class="card-dialog-title" style="background-color: #FFF2F2;">
              <span class="dialog-title font-weight-bold">Delete Confirmation</span>
              <v-btn icon variant="text" density="comfortable" @click="closeDeleteDialog">
                <img src="@/assets/Vector.svg" alt="icon" width="12" height="12">
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-6 pb-4 px-4 body-text">
              Do you want to confirm deletion of all these questions? This action cannot be undone.
            </v-card-text>
            <hr style="border: none; border-top: 1px solid #c9c9c9;" />
            <v-card-actions class="mt-2 mb-2 justify-end">
              <v-btn class="delete-confirm-btn" :loading="deleting" @click="confirmDelete">
                <img src="@/assets/heroicons_trash-solid.svg" alt="img" width="17" height="22" class="mr-2">
                <p style="color: #ffffff; font-size: 14px; font-weight: 500;">Delete</p>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-card>
    </v-container>

    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import LogTrace from "@/api/function.js";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
export default {
  name: "ValidationNegative",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  mixins: [checkPermissionTwo, LogTrace],
  data: () => ({
    showSuccess: false,
    successMessage: "",
    deleting: false,
    _toastTimer: null,
    itemToDelete: null,
    showDeleteDialog: false,
    uploadDialog: false,
    checkbox1: false,
    EditdialogUser: false,
    AddVector: false,
    dialog: false,
    loadingTable: false,
    loading: true,
    loadingDownload: true,
    today: null,
    searchNegativeName: null,
    searchDebounceTimer: null,
    searchDebounceMs: 350,
    requestVector: {
      modelType: null,
      modelId: null,
      vectordbName: null,
      entity: null,
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    DDModel: [],
    files: [],
    dataTable: [],
    headers: [],
    isSearch: false,
    isFirst: true,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,

    showTable: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    sortBy: [],
    sortDesc: [],
  }),
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    queueSearch() {
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }

      this.searchDebounceTimer = setTimeout(() => {
        this.triggerSearch();
      }, this.searchDebounceMs);
    },
    triggerSearch() {
      this.options.page = 1;
      this.Get();
    },
    clearSearch() {
      this.searchNegativeName = null;
      this.options.page = 1;
      this.Get();
    },
    Get() {
      let self = this;
      self.loadingTable = true;

      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }
      
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.searchNegativeName,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableValidationNegative(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
            self.options.page = temp.page;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDefault() {
      let self = this;
      self.loadingTable = true;
      const { page, itemsPerPage } = this.options;
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.searchNegativeName,
        sortDesc: null,
        sortBy: null,
      };
      self.$call.GetTableValidationNegative(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
            self.options.page = temp.page;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Search() {
      let self = this;
      self.isSearch = true;
      self.GetDefault();
    },
    back(e) {
      if (e) {
        this.EditdialogUser = false;
        this.AddVector = false;
      }
    },
    openDeleteDialog(item) {
      this.itemToDelete = item;
      this.showDeleteDialog = true;
    },
    closeDeleteDialog() {
      if (this.deleting) return;
      this.showDeleteDialog = false;
      this.itemToDelete = null;
    },
    confirmDelete() {
      let self = this;
      if (!self.itemToDelete || self.deleting) return;
      self.deleting = true;
      self.dialog = true;
      self.showDeleteDialog = false;
      self.$call.DeleteValidationNegative(
        self.itemToDelete,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.itemToDelete = null;
              self.successMessage = "Successfully Deleted !";
              self.showSuccess = true;
              clearTimeout(self._toastTimer);
              self._toastTimer = setTimeout(() => {
                self.showSuccess = false;
              }, 3000);
              self.Clear();
              self.Get();
            }
            self.dialog = false;
            self.deleting = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.deleting = false;
            self.Adddialog = false;
            console.error(errorResource);
          }
      );
    },
    Add() {
      let self = this;
      self.$router.push({
        name: "ValidationNegativeDetail",
        query: {
          // id: null,
        },
      });
    },
    Edit(item) {
      let self = this;
      self.$router.push({
        name: "ValidationNegativeDetail",
        query: {
          id: item.id,
        },
      });
    },
    Clear() {
      let self = this;

      self.EditdialogUser = false;
      self.AddVector = false;
      self.showTable = false;

      self.requestVector.entity = null;
      self.requestVector.modelId = null;
      self.requestVector.modelType = null;
      self.requestVector.vectordbName = null;

      self.searchNegativeName = null;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1;

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    download() {
      const data = [];
      data.push("text_org,text_en\n");
      data.push("ชื่อบทความ (วรรณคดี): พระอภัยมณี,\n");
      data.push("Article Title (Literature): Phra Abhayamani,\n");
      data.push("Article Title (Literature): Phra Abhayamani (พระอภัยมณี),");

      const a = document.createElement("a");
      let blob = new Blob(data, { type: "data:text/csv;charset=utf-8" });
      const url = window.URL.createObjectURL(blob);

      a.href = url;
      a.download = "upload_vector.csv";
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    },
  },
  mounted() {
    this.GetDate();
    this.headers = [
      { title: this.$t("no"), align: "left", sortable: false },
      {
        title: "Negative Question Set",
        align: "left",
        sortable: true,
        value: "Name",
      },
      {
        title: "Create by",
        align: "left",
        sortable: true,
        value: "CreateBy",
      },
      { title: this.$t("manage"), align: "center", sortable: false, width: "150px" },
    ];
  },
  beforeUnmount() {
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = null;
    }
  },
  beforeDestroy() {
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = null;
    }
  },
};
</script>
<style scoped>
.success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg,#2ABF56,#135928);
  color: #ffffff;
  padding: 10px 24px;
  display: flex;
  align-items: center !important;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 2100;
  width: 50%;
  max-width: 900px;
  min-width: 320px;
  justify-content: center !important;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 110px;
}
.card2 {
  border: 1px solid #DCDCDC;
  border-radius: 16px !important;
  box-shadow: none;
}
.search-input {
  max-width: 280px;
  background: #ffffff;
  border: 1px solid #C9C9C9;
  border-radius: 12px;
}
.search-input :deep(.v-field__field) {
  align-items: center;
}
.search-input :deep(input) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 20px;
  min-height: 40px;
  display: flex;
  align-items: center;
  font-size: 13px;
}
.search-icon {
  margin-left: 12px;
  margin-top: -4px;
  height: 18px;
}
.products-header-button {
  display: flex;
  flex-direction: row;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 10px;
  width: 100px;
  justify-content: center !important;
  align-items: center !important;
  padding: 11px 8px;
  gap: 6px;
  margin-right: 16px;
}
.products-header-button:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
}
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 700;
  font-size: 16px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 700;
  font-size: 16px;
}
.delete-dialog-group {
  margin-top: -180px;
}
.delete-dialog-card {
  border-radius: 12px !important;
}
.card-dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
}
.dialog-title {
  margin-top: 8px;
  font-size: 16px !important;
  color: #C30000 !important;
}
.delete-confirm-btn {
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  gap: 16px;
  border-radius: 12px;
  width: 120px;
  background-color: #C30000;
}
.card {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}
</style>
